import React, { Component } from "react";
import "./Header.css";
import { Fade } from "react-awesome-reveal";
import { NavLink, Link } from "react-router-dom";
import { greeting, settings } from "../../../portfolio";
import SeoHeader from "./SeoHeader";
import Navbar from "./Navbar";
import {ThemeProps} from "../../styles/themeprops";

type State = {
  redirect: boolean,
}

type Props = {
  theme: ThemeProps,
}

const onMouseEnter = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, color:string) => {
  const targetElem = (event.target as HTMLInputElement);
  targetElem.style.backgroundColor = color;
};

const onMouseOut = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
  const targetElem = (event.target as HTMLInputElement);
  targetElem.style.backgroundColor = "transparent";
};

class Header extends Component<Props,State> {
  render() {
    const theme = this.props.theme;
    const link = settings.isSplash ? "/splash" : "home";
    return (
      <div>
        <SeoHeader />
        <div>
          <Navbar theme={theme}/>
        </div>
      </div>
    );
  }
}
export default Header;
